import { render, staticRenderFns } from "./successDialog.vue?vue&type=template&id=31acc939&scoped=true"
import script from "./successDialog.vue?vue&type=script&lang=js"
export * from "./successDialog.vue?vue&type=script&lang=js"
import style0 from "./successDialog.vue?vue&type=style&index=0&id=31acc939&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31acc939",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31acc939')) {
      api.createRecord('31acc939', component.options)
    } else {
      api.reload('31acc939', component.options)
    }
    module.hot.accept("./successDialog.vue?vue&type=template&id=31acc939&scoped=true", function () {
      api.rerender('31acc939', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/init/successDialog.vue"
export default component.exports